import RequestType from "../constants/requestType";
import ApiService from "../services/apiService";

import {apiRoutes} from '../constants/apiRoutes';
import {toastr} from 'react-redux-toastr'
import {actionTypes} from "../constants/actionTypes";

const getSignedDocument = (quotationId) => {
  return async (dispatch) => {
    try {
      let url = apiRoutes.signedDocumentRelated.getSignedDocument.replace('{quotationId}', quotationId);
      const response = await ApiService.performRequest(RequestType.GET, url);

      if (response && response.success) {
        dispatch(getSignedDocumentSuccess(response.document));
      }
    } catch (error) {
      toastr.error('Ophalen van documenten mislukt', error.message);
    }
  }
};

const getSignedDocumentSuccess = (response) => {
  return {
    type: actionTypes.getSignedDocument,
    response
  }
};

const addSignedDocument = (quotationId, data) => {
  return async (dispatch) => {
    try {
      const url = apiRoutes.signedDocumentRelated.addSignedDocument.replace('{quotationId}', quotationId);
      const response = await ApiService.performRequest(RequestType.POST_MULTIPART, url, data);

      if (response && response.success) {
        dispatch(addQuotationDocumentSuccess(response.document));
      }
    } catch (error) {
      toastr.error('Toevoegen mislukt. Probeer het opnieuw', error.message);
    }
  }
};

const addQuotationDocumentSuccess = (response) => {
  return {
    type: actionTypes.addSignedDocument,
    response
  }
};

const updateSignedDocument = (quotationId, data) => {
  return async (dispatch) => {
    try {
      const url = apiRoutes.signedDocumentRelated.updateSignedDocument.replace('{quotationId}', quotationId);
      const response = await ApiService.performRequest(RequestType.POST_MULTIPART, url, data);

      if (response && response.success) {
        dispatch(updateQuotationDocumentSuccess(response.document));
      }
    } catch (error) {
      toastr.error('Toevoegen mislukt. Probeer het opnieuw', error.message);
    }
  }
};

const updateQuotationDocumentSuccess = (response) => {
  return {
    type: actionTypes.updateSignedDocument,
    response
  }
};

const downloadSignedDocument = (documentID) => {
  return async (dispatch) => {
    try {
      const url = apiRoutes.signedDocumentRelated.downloadSignedDocument.replace('{signedDocumentId}', documentID);

      const response = await ApiService.performRequest(RequestType.GETFILE, url);

      dispatch(downloadQuotationDocumentSuccess(response));

      return true;
    } catch ({message}) {
      toastr.error('Kan word document niet downloaden', message);
    }
  }
};

const downloadQuotationDocumentSuccess = (response) => {
  return {
    type: actionTypes.downloadSignedDocument,
    response
  }
};

export default {
  getSignedDocument,
  addSignedDocument,
  updateSignedDocument,
  downloadSignedDocument
}
